import { groupBy } from "lodash"

import { CartItemType, GetCartResponseType } from "@mono/essentials/entities/cart/types"
import { GetOrderDetailsResponseType, OrderItemType } from "@mono/essentials/types/OrderTypes"

export const getAddOnPricing = async (
  cartData?: GetCartResponseType["data"],
  orderData?: GetOrderDetailsResponseType
) => {
  const addons = (cartData || orderData)?.items
    ?.filter((item: OrderItemType | CartItemType) => item.parent_id)
    ?.map((item: OrderItemType | CartItemType) => {
      ;(item as CartItemType).availability = item?.product?.merchandise?.availability
      return item
    })

  const availabilityByData = groupBy(addons, "availability")
  const participants = availabilityByData.participant ?? []
  const customers = availabilityByData.customer ?? []
  const uniqueCartParticipantIds = [
    ...new Set(
      participants.map((item: { cart_participant_id: string }) => item.cart_participant_id)
    ),
  ]

  const uniqueCustomerUnits = new Set()
  const uniqueCustomerProducts = new Set()
  customers.forEach((item) => {
    uniqueCustomerProducts.add(item?.product?.id as string)
    item.quantities.forEach((quantity) => {
      uniqueCustomerUnits.add(quantity.unit?.id) // Assuming "unit" has a "name" property
    })
  })
  const uniqueCustomerUnitsIds = Array.from(uniqueCustomerUnits)
  const uniqueCustomerProductsIds = Array.from(uniqueCustomerProducts)

  const uniqueUnits = new Set()
  const uniqueProducts = new Set()
  participants.forEach((item) => {
    uniqueProducts.add(item?.product?.id as string)
    item.quantities.forEach((quantity) => {
      uniqueUnits.add(quantity.unit?.id) // Assuming "unit" has a "name" property
    })
  })
  const uniqueUnitsIds = Array.from(uniqueUnits)
  const uniqueProductsIds = Array.from(uniqueProducts)

  const data: Record<string, string> = {}
  uniqueProductsIds.forEach((productsId) => {
    uniqueCartParticipantIds.forEach((participantIds) => {
      uniqueUnitsIds.forEach((unitIds) => {
        const foundItem = addons?.find((item) => {
          return (
            (item as CartItemType).cart_participant_id === participantIds &&
            item.product.id === productsId &&
            item.quantities.length > 0 && // Ensure quantities array is not empty
            item.quantities?.[0]?.unit?.id === unitIds
          )
        })
        data[`${productsId}-${unitIds}-${participantIds}`] = foundItem?.formatted_total as string
      })
    })
  })

  uniqueCustomerProductsIds.forEach((productsId) => {
    customers.forEach(() => {
      uniqueCustomerUnitsIds.forEach((unitIds) => {
        const foundItem = addons?.find((item) => {
          return (
            (item as CartItemType).cart_participant_id === null &&
            item.product.id === productsId &&
            item.quantities.length > 0 && // Ensure quantities array is not empty
            item.quantities?.[0]?.unit?.id === unitIds
          )
        })
        data[`${productsId}-${unitIds}-undefined`] = foundItem?.formatted_total as string
      })
    })
  })
  return data
}
